import { combineReducers } from "redux";

import Auth from "./Auth/AuthReducer";

const rootReducer = combineReducers({
  Auth
 });

export default rootReducer
